// src/hooks/useSeasonalTheme.ts
// ★ Convenience hook for accessing the seasonal theme context.

import { useContext } from 'react';
import { SeasonalThemeContext, SeasonalThemeContextValue } from '../contexts/SeasonalThemeProvider';

/**
 * Returns the current seasonal theme context.
 *
 * @example
 * const { season, isChristmas, isHalloween } = useSeasonalTheme();
 * if (isChristmas) return <ChristmasHeader />;
 */
export function useSeasonalTheme(): SeasonalThemeContextValue {
    return useContext(SeasonalThemeContext);
}

export default useSeasonalTheme;
